<template>
  <div class="content">
    <div class="left">
      <div style="display: flex; flex-direction: column; margin-bottom: 30px">
        <span style="font-size: 24px; color: #333333; margin-bottom: 20px">{{
            $t("profile.bind")
          }}</span>
        <div>
          <el-button type="primary" @click="openDialog">{{
              $t("profile.bind")
            }}</el-button>
          <el-button type="success" @click="openWechatDialog">
            绑定微信
          </el-button>
        </div>
      </div>
      <div class="form">
        <el-table :data="tabletData" style="width: 100%">
          <el-table-column prop="userName" label="账号名称"> </el-table-column>
          <el-table-column prop="main" label="是否主账号">
            <template slot-scope="scope">
              {{ scope.row.main ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column prop="dataType" label="账号类型">
            <template slot-scope="scope">
              {{
                scope.row.dataType == 0
                  ? "校内数据"
                  : scope.row.dataType == 1
                    ? "注册数据"
                    : scope.row.dataType == 2
                      ? "微信数据"
                      : scope.row.dataType == 3
                        ? "QQ数据"
                        : scope.row.dataType == 4
                          ? "钉钉数据"
                          : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="isDefault" label="是否默认">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isDefault"
                :active-value="1"
                :inactive-value="0"
                @change="handleSwitchChange(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="oper"
            :label="$t('profile.monitorPage.operations')"
          >
            <template slot-scope="scope">
              <el-button @click="deleteRow(scope.row)" type="text"
              >解绑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      title="绑定账号"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <!-- 表单内容 -->
      <el-form
        ref="verifyForm"
        :model="form"
        :rules="rules"
        label-width="100px"
        class="verify-form"
      >
        <!-- 用户名 -->
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入用户名"
            maxlength="20"
          ></el-input>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            placeholder="请输入密码"
            type="password"
            maxlength="20"
          ></el-input>
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item label="验证码" prop="verifyCode">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input
                v-model="form.verifyCode"
                placeholder="请输入验证码"
                maxlength="6"
              ></el-input>
            </el-col>
            <el-col :span="10">
              <!-- 验证码图片，可点击刷新 -->
              <img
                :src="graphCodeUrl"
                alt="图形验证码"
                @error="refreshGraphCode"
                @click="refreshGraphCode"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>

      <!-- 弹窗底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 微信登录弹窗 -->
    <el-dialog
      title="微信绑定"
      :visible.sync="wechatDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="400px"
    >
      <wechat-login ref="wechatLoginRef" :redirectUri="'https://ywtb.cqtc.edu.cn/personalCenter#accountBinding'"/>

      <!-- 弹窗底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="wechatDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getImageUrl } from "@/utils/imageHelper";
import request from "@/api/request";
import wechatLogin from "@/components/wechatLogin/WechatLogin.vue";
import {Message} from "element-ui";

export default {
  components: {
    wechatLogin
  },
  data() {
    return {
      avtor: require("@/assets/img/personal/avtor.png"),
      userInfo: {},
      tabletData: [],
      // 控制弹窗显示/隐藏
      dialogVisible: false,
      // 微信登录弹窗显示/隐藏
      wechatDialogVisible: false,
      // 表单数据
      form: {
        username: "",
        password: "",
        verifyCode: "",
      },
      // 验证规则
      graphCodeUrl: "", // 图形验证码图片地址
      // 可根据需要添加表单验证规则
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 6, message: "验证码长度为4-6位", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    // 计算属性方式
    avatarUrl() {
      return getImageUrl(this.avtor);
    },
  },
  mounted() {
  },
  watch: {
    // 监听URL变化
    '$route.query': {
      handler(newQuery) {
        console.log("执行了bind_mounted",newQuery)
        this.handleCallback();
      },
      immediate: true
    }
  },
  created() {
    this.handleCallback();
    this.userInfo = {
      ...JSON.parse(localStorage.getItem("accountInfo"))?.data,
    };
    this.avtor = this.userInfo.avatar;
    this.getDataList();
  },
  methods: {
    getUrlKey: name => {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
      )
    },
    async handleCallback(callback) {

      const code = this.getUrlKey('code');
      const state = this.getUrlKey('state');

      if (!code) {
        // this.showError("微信登录失败：缺少授权码");
        return;
      }

      try {
        // 发送code到后端
        const res = await  request({
          url: '/api/auth/wx/bind',
          method: "post",
          data:{
            code,
            state
          }
        })
        console.log(res)
        this.wechatDialogVisible = false
        // 清除URL参数
        window.history.replaceState({}, document.title, window.location.pathname);
        if (res?.code !== 200) {
          Message.error(`绑定失败`);
          return;
        }

        Message.success(`绑定成功`);
        // 刷新数据列表
        this.getDataList();
      } catch (error) {
        Message.error(`微信登录失败：${error.response?.data?.message || error.message}`);
      }
    },
    // 刷新验证码
    refreshGraphCode() {
      request("/api/auth/captcha/img", { responseType: "blob" })
        .then((res) => {
          this.graphCodeUrl = URL.createObjectURL(res);
        })
        .catch((error) => {});
    },
    // 提交表单
    submitForm() {
      this.$refs.verifyForm.validate((valid) => {
        if (valid) {
          // 表单验证通过，执行提交逻辑
          console.log("提交表单", this.form);
          request({
            url: `/api/user/ref/account`,
            method: "post",
            data: {
              username: this.form.username,
              password: this.form.password,
              validateCode: this.form.verifyCode,
            },
          })
            .then((res) => {
              this.form = {
                username: "",
                password: "",
                verifyCode: "",
              };
              this.$message(res.msg)
              this.dialogVisible = false
              this.getDataList();
            })
            .catch((error) => {
              this.form = {
                username: "",
                password: "",
                verifyCode: "",
              };
            });
          this.$message(error.msg)
          this.refreshGraphCode()
        }
      });
    },

    handleSwitchChange(data) {
      request({
        url: `/api/user/ref/setting?id=${data.id}&isDefault=${data.isDefault}`,
        method: "get",
      })
        .then((res) => {
        })
        .catch((error) => {});
    },
    getDataList() {
      request({
        url: `/api/user/ref/list`,
        method: "get",
      })
        .then((res) => {
          this.tabletData = [...res];
        })
        .catch((error) => {});
    },
    deleteRow(data) {
      if (data.main) {
        this.$message.warning("主账号不能解绑");
        return;
      }
      request({
        url: `/api/user/ref/del?id=${data?.id}`,
        method: "get",
      })
        .then((res) => {
          this.$message.success("解绑成功");
          this.getDataList();
        })
        .catch((error) => {});
    },
    openDialog() {
      this.dialogVisible = true;
    },
    // 打开微信登录弹窗
    openWechatDialog() {
      this.wechatDialogVisible = true;
      // 确保微信登录组件初始化
      this.$nextTick(() => {
        if (this.$refs.wechatLoginRef) {
          this.$refs.wechatLoginRef.initWechatLogin();
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: 600px;
  .left {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;
    .form {
      ::v-deep .el-table__header th {
        background-color: #f5f7fb;
        font-weight: bold;
        color: #333333;
      }
    }
  }
  .right {
    background-image: url("@/assets/img/personal/editPassBg.png");
    background-size: contain;
    background-repeat: no-repeat;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20%;
    }
    .idNumber {
      display: flex;
      flex-direction: column;
      padding: 15px;
      font-size: 14px;
      color: #666666;
      background: #f5f7fb;
      border-radius: 4px;
      width: 80%;
      margin-top: 15px;
    }
  }
}
</style>
